<template>
    <span :class="{ link: !error }" class="link" @click.stop="openObject">
        <slot />
    </span>
</template>

<script>
import GlobalMixins from "@/mixins/global";

export default {
    mixins: [GlobalMixins],
    props: {
        object: {
            type: String,
            required: true,
        },
        params: {
            type: Object,
            required: true,
        },
    },
    methods: {
        async openObject() {
            this.$utils.lookup(this.object, this.params).then((id) => {
                if (!id) {
                    this.addAlert({ text: this.$translate("invalidLink"), type: "error" });
                    this.error = true;
                    return;
                }
                let params = {};
                params[`${this.object}_id`] = id;

                this.routerPush({
                    name: this.object,
                    params,
                });
            });
        },
    },
    data() {
        return {
            error: false,
        };
    },
    i18n: {
        messages: {
            en: {
                invalidLink: "Invalid link",
            },
            fr: {
                invalidLink: "Lien invalide",
            },
        },
    },
};
</script>
